<p-accordion *ngIf="items">
    <p-accordionTab *ngFor="let item of items" [selected]="item.expanded">
        <ng-template pTemplate="header">
            <span class="block inline-flex align-items-center justify-content-center border-circle surface-300 mr-2 text-700 text-lg" style="width: 2rem; height: 2rem;">
                <i [ngClass]="item.icon">

                </i></span>
                <span class="text-2xl font-medium">{{item.label}}</span>
            </ng-template>

        <p [innerHTML]="item.fragment"></p>
    </p-accordionTab>
   
</p-accordion>